
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/signatureContainer',['Vue', 'vue!basicComponents/modal', 'vue!../reusableComponents/segment', 'vue!../reusableComponents/signature'],function(Vue, modal, segment, signaturePad){
        return {
            name:'signatureContainer',
            template:template,
            components: {
                segment: segment,
                modal: modal,
                'signature-pad' : signaturePad
            },
            data: function() {
                return {
                    signatureData: null,
                    isPolicyChecked: false
                }
            },
            computed: {
                disableConfirmButton: function() {
                    return !this.signatureData || this.$store.getters['pmsCheckin/disableConfirmButton'] || !this.isPolicyChecked;
                }
            },
            methods: {
                clearSignature: function() {
                    this.$refs.sigPad.clearSignature();
                },
                handleSignatureUpdate: function(data) {
                    this.signatureData = data;
                },
                confirmSignature: function() {
                    this.$store.dispatch('pmsCheckin/updateFolio', {FolioId: this.$globalParameters.pmsFolioId, signature: this.signatureData});
                }
            }
        }
    })
})('<segment> <template v-slot:header> <i class="fas fa-file-contract"></i> {{localization.roomReservation.pmsCheckIn.signatureHeader}} </template> <template v-slot:body> <div class="row-fluid flex"> <div class="sigPadWrapper"> <signature-pad ref="sigPad" @update="handleSignatureUpdate" /> </div> <label class="check_policy"> {{localization.roomReservation.pmsCheckIn.policyCheckLavel}} <input class="check_policy_checkbox" type="checkbox" v-model="isPolicyChecked" > </label> <div class="span6 alignEnd"> <div class="span6"> <button class="btn yellowButton fullWidth" @click="clearSignature">{{localization.roomReservation.pmsCheckIn.clearSignatureLabel}}</button> </div> <div class="span6"> <modal className="btn btn-warning yellowButton fullWidth" :triggerButtonText="localization.roomReservation.pmsCheckIn.confirmSignature" @confirm="confirmSignature" modalId="submitCheckIn" :confirmButtonText="localization.roomReservation.pmsCheckIn.modalConfirmButtonText" :closeButtonText="localization.general.close" :disabled="disableConfirmButton"> <template v-slot:modalHeader> <h3 id="submitCheckInLabel">{{localization.roomReservation.pmsCheckIn.confirmSubmitModalHeader}}</h3> </template> <template v-slot:modalBody> <p>{{localization.roomReservation.pmsCheckIn.confirmSubmitModalMessage}}</p> </template> </modal> </div> </div> </div> </template> </segment>');
